import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorRelatedConditionsRefineButton = props => {
  const {
    dataSeleniumInfo,
    onClick,
    disabled
  } = props;
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-info": dataSeleniumInfo,
    "data-selenium-test": "fr-refine-btn",
    disabled: disabled,
    onClick: onClick,
    size: "xs",
    use: "tertiary-light",
    responsive: false,
    marginInlineStart: "0",
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.refineButton"
    })
  });
};
export default EditorRelatedConditionsRefineButton;